module.exports = __webpack_public_path__ + "img/2015077.f16ed76c.svg";